import React from 'react';
import PropTypes from 'prop-types';
import './UnitSizeComparison.scss';
import { Image } from 'components/core/Image';

export function UnitSizeComparison({ icon }) {
	return (
		<div className="vehicle-storage-unit">
			{icon && (
				<Image
					src={icon}
					alt="Vehicle Storage Icon"
				/>
			)}
		</div>
	);
}

UnitSizeComparison.propTypes = {
	icon: PropTypes.string,
};

export default UnitSizeComparison;
